<glxy-currency-field
  [formControl]="control"
  [label]="label | translate"
  [maximumValue]="'100000000'"
  [minimumValue]="'-100000000'"
  [currencyCode]="selectedCurrencyCode()"
  (keydown.enter)="$event.preventDefault()"
  [required]="required"
>
</glxy-currency-field>
